import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

import { Box, Grid, Typography } from "@mui/material";

import { useParams } from "react-router-dom";
import { FullHeightLoader } from "../../components/Loader/FullHeightLoader";
import { PlayoffProvider } from "../../context/PlayoffContext";
import { getPlayoffDetails } from "../../apis/Playoff";
import { PlayoffForm } from "../../components/Playoff/PlayoffForm";

export const EditPlayoff = () => {
	const [playoff, setPlayoff] = useState();

	const [loading, setLoading] = useState(false);

	const { id } = useParams();

	useEffect(() => {
		setLoading(true);
		debounce(async () => {
			const playoff = await getPlayoffDetails(id);
			console.log(playoff);
			setPlayoff(playoff);
			setLoading(false);
		})();
	}, [id]);

	return (
		<PlayoffProvider>
			{loading && <FullHeightLoader />}
			<Grid container justifyContent="center" spacing={2}>
				<ToastContainer />
				<Grid item xs={12} md={8}>
					<Box
						display="flex"
						justifyContent="space-between"
						sx={{ pt: 2 }}
					>
						<Typography variant="h6" gutterBottom>
							Edit Playoff
						</Typography>
					</Box>
				</Grid>
				<PlayoffForm playoff={playoff} />
			</Grid>
		</PlayoffProvider>
	);
};
